import { withTranslations } from '@/utils/Language';
import planEn from '@/assets/i18n/plan/en.json';
import tagsEn from '@/assets/i18n/tags/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...planEn, ...tagsEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/plan/${lang}.json`),
      import(`@/assets/i18n/tags/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([plan, tags, ui, languages, languagesTranslated]) => ({
      ...plan.default,
      ...tags.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
